import script from "./OperatorApplicationDialogTextareaButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationDialogTextareaButton.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationDialogTextareaButton.vue?vue&type=style&index=0&id=74719f5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74719f5a"]])

export default __exports__